export enum ImageUrls {
  Client = 'https://ae-happines-zoho-images-storage.s3.us-east-2.amazonaws.com/star.png',
  Puzzle = 'https://ae-happines-zoho-images-storage.s3.us-east-2.amazonaws.com/puzzle.png',
  Mail = 'https://ae-happines-zoho-images-storage.s3.us-east-2.amazonaws.com/mail-dynamic-color.png',
  Tick = 'https://ae-happines-zoho-images-storage.s3.us-east-2.amazonaws.com/tick-dynamic-color.png',
  Time = 'https://ae-happines-zoho-images-storage.s3.us-east-2.amazonaws.com/new-year-time.png',
}
